import Template404 from './Template404'

export default Template404
